import styled from 'styled-components';

export const HeroContainer = styled.div`
  position: relative;
  padding: calc(32px + env(safe-area-inset-top)) 24px
    calc(32px + env(safe-area-inset-bottom)) 24px;
  display: flex;
  justify-content: center;
  overflow: hidden;
  background: ${({ theme }) => theme.card_light};

  @media (max-width: 960px) {
    padding: calc(30px + env(safe-area-inset-top)) 16px
      calc(30px + env(safe-area-inset-bottom)) 16px;
  }

  @media (max-width: 640px) {
    padding: calc(14px + env(safe-area-inset-top)) 16px
      calc(14px + env(safe-area-inset-bottom)) 16px;
  }
`;

export const HeroBgWrapper = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 70% 95%, 0 100%);
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 70% 95%, 0 100%);
  overflow: hidden;
  z-index: var(--z-base);
`;

export const HeroBg = styled.div`
  position: absolute;
  inset: 0;
  max-width: 1360px;
  margin: 0 auto;
  pointer-events: none;
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1100px;
  z-index: var(--z-content);

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  @media (max-width: 960px) {
    order: 2;
    margin-bottom: 32px;
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  order: 2;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 960px) {
    order: 1;
    margin-bottom: 80px;
    margin-top: 20px;
  }

  @media (max-width: 640px) {
    margin-bottom: 32px;
    margin-top: 16px;
  }

  @media (max-width: 480px) {
    margin-bottom: 24px;
    margin-top: 12px;
  }

  @media (max-width: 380px) {
    margin-bottom: 20px;
    margin-top: 8px;
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 44px;
  line-height: 1.2;
  color: ${({ theme }) => theme.text_primary};
  margin-bottom: 12px;

  @media (max-width: 640px) {
    font-size: 34px;
  }
`;

export const TextLoop = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 1.3;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;

  @media (max-width: 960px) {
    font-size: 20px;
  }

  @media (max-width: 640px) {
    font-size: 18px;
  }
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.primary};
`;

export const SubTitle = styled.div`
  font-size: 16px;
  line-height: 1.6;
  margin: 12px 0;
  max-width: 520px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_primary + 95};
  text-align: center;

  @media (max-width: 640px) {
    font-size: 16px;
  }
`;

export const LetsCollaborateButton = styled.a`
  appearance: button;
  text-decoration: none;
  width: 100%;
  max-width: 280px;
  text-align: center;
  padding: 14px 0;
  color: white;
  border-radius: 15px;
  cursor: pointer;
  font-size: 17px;
  font-weight: 600;
  background: ${({ theme }) => theme.primary};
  background: linear-gradient(
    225deg,
    ${({ theme }) => theme.primary} 0%,
    ${({ theme }) => theme.primary}dd 100%
  );
  border: none;
  box-sizing: border-box;
  transition:
    box-shadow 0.3s ease,
    transform 0.2s ease;

  &:hover {
    box-shadow:
      0 0 0 2px rgba(255, 255, 255, 0.95),
      0 0 0 4px rgba(0, 0, 0, 0.95);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 640px) {
    font-size: 16px;
    padding: 12px 0;
  }

  @media (max-width: 320px) {
    max-width: 240px;
    font-size: 14px;
    padding: 10px 0;
  }
`;
